import React from 'react';
import './Header.css';
import Slider from "react-slick";
//import AliceCarousel from 'react-alice-carousel';
//import 'react-alice-carousel/lib/alice-carousel.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import slide1 from '../../assets/images/TheDoctorAward-1.png';
import slide2 from '../../assets/images/PaulAndClaire-2.png';
import slide3 from '../../assets/images/TerryAndClaire-3.png';
import slide4 from '../../assets/images/JeffAndClaire-4.png';
import slide5 from '../../assets/images/JennAndClaire-5.png';
import slide6 from '../../assets/images/ClaireHutchinson-6.png';
import slide7 from '../../assets/images/ClaireHutchinson-7.png';
import slide8 from '../../assets/images/Claire-8.png';
//import filmstrip from '../../assets/images/filmstripCarousel.png';

/* const responsive = { 
  0: { items: 1 },
  568: { items: 2 },
  1024: { items: 4 },
  1717: { items: 8 }
}; */

var settings = {
  dots: false,
  infinite: true,
  speed: 3000,
  arrows: false,
  slidesToShow: 8,
  slidesToScroll: 1,
  initialSlide: 7,
  autoplaySpeed: 6000,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1800,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
};

function Header() {
  return (
    // <div id="header"><img alt="Claire Hutchinson Header" src={filmstrip} /></div>

  <Slider {...settings} >
      <img src={slide1} alt="Claire Hutchinson receiving award for The Doctor script" />
      <img src={slide2} alt="Paul Boge and Claire Hutchinson" />
      <img src={slide3} alt="Terry Porter and Claire Hutchinson" />
      <img src={slide4} alt="Jeffrey Worthington Claire Hutchinson" />
      <img src={slide5} alt="Jenn Gotzon and Claire Hutchinson" />
      <img src={slide6} alt="Claire Hutchinson" />
      <img src={slide7} alt="Claire Hutchinson" />
      <img src={slide8} alt="Claire Hutchinson" />
    </Slider>
    )
  }
      
export default Header; 
